import {ICasinofiedApplicationAdapter} from "./casinofied-application-adapter.interface";
import {IDivHostedAppInitParameters} from "@sparkware/uc-sdk-core";

export class CasinofiedRegularApplicationAdapter implements ICasinofiedApplicationAdapter {
    constructor(private readonly applicationObject) {
    }

    init(initParams: IDivHostedAppInitParameters) {
        this.applicationObject.init(initParams);
    }

    focus(): void {
        //nothing to do here
    }
}